let selectors = {
  videoModalElement: document.querySelector('.videoModal'),
  videoClose: document.querySelector('.videoModal__button'),
  videoContainer: document.querySelector('.videoModal__video'),
  activeClass: 'videoModal--active'
}

const watchForKeyDownEvent = () => document.addEventListener('keydown', (e) => e.key === "Escape" ? closeModal() : null);

const watchModalEvents = () =>  {

  let { videoClose } = selectors;

  videoClose.addEventListener('click', () => closeModal());

  watchForKeyDownEvent();

}

const closeModal = () => {

  let { videoModalElement, videoContainer, activeClass } = selectors;

  videoModalElement.classList.remove(activeClass);
  videoContainer.innerHTML = '';

}

const openModal = () => {
  let { videoModalElement, activeClass } = selectors;
  videoModalElement.classList.add(activeClass);
  watchModalEvents();
}

const displayContent = videoUrl => {
  selectors.videoContainer.innerHTML = `<iframe allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src="${videoUrl}&autoplay=1&amp;hd=1&amp;show_title=1&amp;show_byline=1&amp;show_portrait=0&amp;fullscreen=1" scrolling="no"></iframe>`;
}

const toggleModal = button => {
  let videoUrl = button.parentElement.lastElementChild.firstElementChild.src;
  displayContent(videoUrl);
  openModal();
}

const watchEvents = videos =>  {
  Array.prototype.forEach.call(videos, (button) => {
    button.addEventListener('click', () => toggleModal(button));
  });
}

const VideoModal = videos => watchEvents(videos);

export default VideoModal;


// WEBPACK FOOTER //
// ./src/js/app/components/VideoModal.js